import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLeaveList,
  updateLeaveApproval,
  getManualEntryList,
  updateManualApproval,
} from "./ApprovalActions";

const initialState = {
  leaveEntryData: [],
  meta: {},

  manualEntryData: [],
  manualMeta: {},

  loading: false,
  error: null,

  approvalLoading: false,
  approvalSuccess: null,
  approvalError: null,
};

const leaveApprovalSlice = createSlice({
  name: "leaveApproval",

  initialState,

  reducers: {},

  extraReducers: (builder) => {
    builder

      // Fetch Leave List
      .addCase(fetchLeaveList.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchLeaveList.fulfilled, (state, action) => {
        state.loading = false;
        state.leaveEntryData = action.payload.data;
        state.meta = {
          totalRecords: action.payload.data[0]?.totalRecords || 0,
          totalPages: action.payload.data[0]?.totalPages || 0,
          pageNumber: action.payload.data[0]?.pageNumber || 1,
          pageSize: action.payload.data[0]?.pageSize || 5,
        };
      })

      .addCase(fetchLeaveList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Approve / Reject
      .addCase(updateLeaveApproval.pending, (state) => {
        state.approvalLoading = true;
      })

      .addCase(updateLeaveApproval.fulfilled, (state, action) => {
        state.approvalLoading = false;
        state.approvalSuccess = action.payload;
      })

      .addCase(updateLeaveApproval.rejected, (state, action) => {
        state.approvalLoading = false;
        state.approvalError = action.payload;
      })
      .addCase(getManualEntryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getManualEntryList.fulfilled, (state, action) => {
        state.loading = false;


  state.manualEntryData = action.payload.data;


        state.manualMeta = {
          totalRecords: action.payload.data.TotalRecords,
          totalPages: action.payload.data.TotalPages,
          pageNumber: action.payload.data.CurrentPage || 1,
          pageSize: action.payload.data.data.length,
        };
      })
      .addCase(getManualEntryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateManualApproval.pending, (state) => {
        state.approvalLoading = true;
      })
      .addCase(updateManualApproval.fulfilled, (state, action) => {
        state.approvalLoading = false;
        state.approvalSuccess = action.payload;
      })
      .addCase(updateManualApproval.rejected, (state, action) => {
        state.approvalLoading = false;
        state.approvalError = action.payload;
      })
  },
});

export default leaveApprovalSlice.reducer;